import { observer } from "mobx-react-lite";
import React from "react";

import { TextBadge, TextBadgeColor, TextBadgeSize } from "@bps/fluent-ui";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";

interface ClaimConsultsRemainingBadgeProps {
  consultNumberText: string | undefined;
  episodeOfCare: EpisodeOfCare;
  hideConsultOnNoClaim?: boolean;
  showConsultsRemaining?: boolean;
  showConsultIndex?: boolean;
}

export const ClaimConsultsRemainingBadge: React.FC<ClaimConsultsRemainingBadgeProps> =
  observer(props => {
    const {
      consultNumberText,
      episodeOfCare,
      hideConsultOnNoClaim,
      showConsultsRemaining,
      showConsultIndex
    } = props;

    const hideConsultBadge =
      hideConsultOnNoClaim && !episodeOfCare.claim?.claimNumber;

    if (
      hideConsultBadge ||
      showConsultsRemaining ||
      (showConsultIndex && consultNumberText)
    ) {
      return null;
    }

    const getConsultsRemainingText = () => {
      const appointmentVisits = episodeOfCare.claim?.appointmentVisits;
      if (appointmentVisits) {
        if (appointmentVisits.length > 1) return "Multiple provider types";
        if (appointmentVisits.length === 1)
          return `${appointmentVisits[0].totalRemaining} consults remain`;
      }
      return "No consults remain";
    };

    return (
      <TextBadge
        badgeColor={TextBadgeColor.lightGrey}
        badgeSize={TextBadgeSize.medium}
      >
        {showConsultsRemaining && getConsultsRemainingText()}
        {showConsultIndex && consultNumberText}
      </TextBadge>
    );
  });
